<template>
  <div class="consolidate-page">
    <div class="page-header">
      <h2>预习</h2>
      <p>提前了解明日课程内容，做好学习准备</p>
    </div>
    <div class="page-empty">
      <i class="fa fa-book"></i>
      <p>预习内容即将上线</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentPreview'
}
</script>

<style lang="less" scoped>
.consolidate-page {
  padding: 32px 40px;
  min-height: 100%;
  box-sizing: border-box;
  background: #f7f8fa;
}

.page-header {
  margin-bottom: 28px;

  h2 {
    margin: 0 0 8px;
    font-size: 22px;
    font-weight: 600;
    color: #1f2329;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #8a8f98;
  }
}

.page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  color: #8a8f98;

  i {
    font-size: 42px;
    margin-bottom: 16px;
    color: #c4c7c5;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
}
</style>
